import Logo from "./Logo";
import "../css/Navbar.css";
import React, { useState } from "react";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const redirectHome = () => {
    window.location.href = "/";
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const currentPath =
    typeof window !== "undefined" ? window.location.pathname : "/";
  const isActive = (path) => {
    if (path === "/") return currentPath === "/";
    return currentPath.startsWith(path);
  };

  return (
    <nav className="main-nav">
      <div className="logo" onClick={redirectHome}>
        <Logo />
      </div>
      
      <button 
        className="hamburger-menu" 
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isMenuOpen}
      >
        <span className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></span>
        <span className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></span>
        <span className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></span>
      </button>

      <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        <a href="/" className={isActive("/") ? "active" : ""} onClick={closeMenu}>
          Home
        </a>
        <a href="/about" className={isActive("/about") ? "active" : ""} onClick={closeMenu}>
          Chi siamo
        </a>
        <a href="/prodotti" className={isActive("/prodotti") ? "active" : ""} onClick={closeMenu}>
          Prodotti
        </a>
        <a href="/offerte" className={isActive("/offerte") ? "active" : ""} onClick={closeMenu}>
          Offerte
        </a>
        <a href="/contatti" className={isActive("/contatti") ? "active" : ""} onClick={closeMenu}>
          Contatti
        </a>
        <a
          href="/agevolazioni"
          className={isActive("/agevolazioni") ? "active" : ""}
          onClick={closeMenu}
        >
          Agevolazioni
        </a>
      </div>
      
      <div className={`nav-overlay ${isMenuOpen ? "show" : ""}`} onClick={closeMenu}></div>
    </nav>
  );
}

export default Navbar;
